import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicNFA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Non-Deterministic Finite Automata (NFA) in TOC"
      videos={[
        "https://www.youtube.com/embed/YGL2d8BZJmI",
        "https://www.youtube.com/embed/XndSEN1z4Ro",
      ]}
      takeaways={[
        { text: "Understand the concept and working of NFA." },
        { text: "Learn how NFA differs from DFA." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicNFA };